// extracted by mini-css-extract-plugin
module.exports = {"encasing":"BodyInfo_encasing__2W3QV","grid":"BodyInfo_grid__KhamE","button":"BodyInfo_button__j_OxD","intro":"BodyInfo_intro__3rG5j","border":"BodyInfo_border__2Lzv2"};